import { useEffect, useMemo, useState } from "react";
import logo from "../../logo.png";
import { useLocationSelection } from "../../context/LocationContext";

const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/menu", label: "Menu", usesSelectedLocation: true },
  { href: "/catering", label: "Catering" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

function PublicHeader({ currentPath, onOpenLocationSelector }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { selectedLocation, cartCount } = useLocationSelection();

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 12);
    }

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const headerClassName = useMemo(() => {
    return `public-header${scrolled ? " public-header--solid" : ""}`;
  }, [scrolled]);

  const navLinks = useMemo(() => {
    return NAV_LINKS.map((link) => {
      if (!link.usesSelectedLocation || !selectedLocation?.slug) {
        return link;
      }

      return {
        ...link,
        href: `/menu/${selectedLocation.slug}`,
      };
    });
  }, [selectedLocation]);

  function isActiveLink(href) {
    if (href === "/") {
      return currentPath === "/";
    }

    if (href.startsWith("/menu")) {
      return currentPath.startsWith("/menu");
    }

    return currentPath.startsWith(href);
  }

  return (
    <header className={headerClassName}>
      <a className="public-brand" href="/" aria-label="Zayas Kitchen home">
        <img alt="Zayas Kitchen" src={logo} />
        <span>Zayas Kitchen</span>
      </a>

      <nav className="public-nav" aria-label="Primary navigation">
        {navLinks.map((link) => (
          <a
            aria-current={isActiveLink(link.href) ? "page" : undefined}
            className="public-nav-link"
            href={link.href}
            key={link.label}
          >
            {link.label}
          </a>
        ))}
      </nav>

      <div className="public-header-actions">
        {selectedLocation ? (
          <button className="public-location-chip" onClick={onOpenLocationSelector} type="button">
            {selectedLocation.name}
          </button>
        ) : null}
        <a className="public-cart-link" href="/cart" aria-label={`Cart with ${cartCount} items`}>
          <span aria-hidden="true">Bag</span>
          <strong>{cartCount}</strong>
        </a>
        <button className="btn btn-primary" onClick={onOpenLocationSelector} type="button">
          Order Now
        </button>
        <button
          aria-expanded={mobileOpen}
          aria-label="Toggle navigation menu"
          className="btn btn-light btn-icon public-menu-toggle"
          onClick={() => setMobileOpen((isOpen) => !isOpen)}
          type="button"
        >
          ?
        </button>
      </div>

      {mobileOpen ? (
        <nav className="public-mobile-nav" aria-label="Mobile navigation">
          {navLinks.map((link) => (
            <a
              aria-current={isActiveLink(link.href) ? "page" : undefined}
              href={link.href}
              key={link.label}
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <button className="btn btn-primary btn-block" onClick={onOpenLocationSelector} type="button">
            Order Now
          </button>
        </nav>
      ) : null}
    </header>
  );
}

export default PublicHeader;